import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

import { Tooltip } from "widgets/feedback";

import styles from "./columnheader.css";

import DropDownIcon from "./DownArrow.svg";
import InfoIcon from "./Info.svg";

export function ColumnHeader(props) {
  const { column, pinColumn, canResize = true } = props;
  const [showMenu, setShowMenu] = useState(false);
  const menuButton = useRef(null);
  function closePopup() {
    menuButton.current.blur();
  }
  return (
    <div
      className={styles.columnheader}
      data-column-header={true}
      data-column-id={column.id}
    >
      {column.icon && <div className={styles.icon}>{column.icon}</div>}
      <div className={`${styles.name} base-600 ellipsis`}>
        {column.name}{" "}
        {column.required ? <span className={styles.required}>*</span> : ""}
      </div>
      {column.hint && (
        <div className={styles.hint}>
          <Tooltip content={column.hint}>
            <InfoIcon />
          </Tooltip>
        </div>
      )}
      {column.headerMenu && (
        <button
          className={styles.dropdown}
          onFocus={() => setShowMenu(true)}
          ref={menuButton}
          // onBlur={() => setShowMenu(false)}
        >
          <DropDownIcon />
          {showMenu && (
            <div className={`${styles.menu} shadow-4dp`}>
              {column.headerMenu({ closePopup, pinColumn })}
            </div>
          )}
        </button>
      )}
      {canResize && (
        <div
          className={styles.resizer}
          data-column-resizer={true}
          data-column-id={column.id}
        />
      )}
    </div>
  );
}

ColumnHeader.propTypes = {
  column: PropTypes.any,
  onResize: PropTypes.func,
  pinColumn: PropTypes.func,
  canResize: PropTypes.bool
};
